// extracted by mini-css-extract-plugin
export default {"botMessageWrapper":"message_botMessageWrapper__Vu3ku"};